<template>
    <div class="center-page">
        <el-page-header style="margin-bottom: 20px;" @back="$router.back()"
                        :content="`${getStateName}评价`"></el-page-header>
        <div v-loading="loading">
            <CommentItem v-for="item in evaluates"
                         :key="item.id"
                         :star="item.star"
                         :name="item.nickname"
                         :text="item.assess"
                         :time="item.created_at"
                         :head="item.portrait"></CommentItem>
            <el-alert v-if="evaluates.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
    </div>
</template>

<script>
    import CommentItem from "../../components/CommentItem";
    export default {
        name: "evaluateList",
        components:{CommentItem},
        data() {
            return {
                id: '',
                state: '',
                evaluates: [],
                loading: false
            }
        },
        created() {
            let {id, state} = this.$route.query;
            this.id = id;
            this.state = state;
            this.allEvaluate();
        },
        computed:{
            getStateName(){
                switch (this.state) {
                    case '0':
                        return '房源'
                    case '3':
                        return '景点'
                    case '4':
                        return '温泉'
                    case '5':
                        return '美食'
                }
            }
        },
        methods: {
            async allEvaluate() {
                this.loading = true;
                let [e, data] = await this.$api.allEvaluateApi({
                    id: this.id,
                    state: this.state
                })
                this.loading = false;
                this.evaluates = data.result.evaluates;
            }
        }
    }
</script>

<style scoped>

</style>
